/* ============================================================
   Stelvio Returns Portal - PASSAGGIO DAL RIMBORSO AL CAMBIO.

   Chi ha chiesto un rimborso riceve nell'email l'offerta del cambio
   gratuito con un bottone che porta qui:
     /pages/returns-portal?order=5166&switch=SC-RC-2026-5166

   PERCHE' L'EMAIL NON STA NEL LINK: dati personali nelle query string
   finiscono nei log del server, in Analytics e nella cronologia del
   browser. Il link porta solo il numero d'ordine; l'email la chiede il
   portale, e resta l'autenticazione.

   COME FUNZIONA: precompila il numero d'ordine e spiega perche' si e'
   qui. Quando il cliente ha superato il riconoscimento (quindi ordine
   ed email verificati), ritira la vecchia richiesta chiamando
   /api/returns/withdraw e lo lascia nella schermata di scelta, dove
   trova cambio taglia/colore e cambio prodotto.

   AUTONOMO: osserva il DOM e non tocca returns-portal.js, cosi' il file
   principale resta intatto e non si creano divergenze fra copie.
   REGOLA: niente backslash in questo file (upload via GraphQL).
   ============================================================ */
(function () {
  var API = 'https://finance.stelviocollection.com/api/returns';
  var TOKEN = '084f91b2df68573eac6733d0742be3926639eda91876bc12';

  var STR = {
    it: {
      intro: 'Vuoi cambiare articolo invece di ricevere il rimborso? Inserisci la email dell’ordine e scegli cosa preferisci: il cambio è gratuito.',
      working: 'Un momento, prepariamo il tuo cambio...',
      done: 'Abbiamo annullato la richiesta di rimborso. Ora scegli il cambio che preferisci: taglia, colore o un altro prodotto.',
      too_late: 'La tua richiesta di rimborso è già in lavorazione, quindi non possiamo cambiarla da qui. Scrivi a sales@stelviocollection.com e ci pensiamo noi.',
      err: 'Non siamo riusciti a passare al cambio. Scrivi a sales@stelviocollection.com e lo gestiamo noi.'
    },
    en: {
      intro: 'Would you like to exchange your item instead of getting a refund? Enter the order email and choose what you prefer: the exchange is free.',
      working: 'One moment, we are preparing your exchange...',
      done: 'We have cancelled your refund request. Now choose the exchange you prefer: size, colour or a different product.',
      too_late: 'Your refund request is already being processed, so we cannot change it here. Write to sales@stelviocollection.com and we will take care of it.',
      err: 'We could not switch to an exchange. Please write to sales@stelviocollection.com and we will handle it.'
    },
    de: {
      intro: 'Möchtest du den Artikel tauschen statt eine Erstattung zu erhalten? Gib die E-Mail der Bestellung ein und wähle, was du bevorzugst: der Umtausch ist kostenlos.',
      working: 'Einen Moment, wir bereiten deinen Umtausch vor...',
      done: 'Wir haben deine Erstattungsanfrage storniert. Wähle jetzt den Umtausch, den du bevorzugst: Größe, Farbe oder ein anderes Produkt.',
      too_late: 'Deine Erstattungsanfrage wird bereits bearbeitet, daher können wir sie hier nicht ändern. Schreib an sales@stelviocollection.com, wir kümmern uns darum.',
      err: 'Der Wechsel zum Umtausch ist fehlgeschlagen. Schreib bitte an sales@stelviocollection.com.'
    }
  };

  function param(nome) {
    var q = window.location.search;
    if (!q || q.length < 2) return '';
    var parti = q.substring(1).split('&');
    for (var i = 0; i < parti.length; i++) {
      var kv = parti[i].split('=');
      if (decodeURIComponent(kv[0]) === nome) return decodeURIComponent(kv[1] || '');
    }
    return '';
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  var ordine = param('order');
  var pratica = param('switch');
  if (!ordine && !pratica) return;

  var fatto = false;

  function banner(root, testo, tipo) {
    var box = root.querySelector('.sc-returns-box');
    if (!box) return;
    var old = box.querySelector('.sc-switch');
    if (old) old.parentNode.removeChild(old);
    var b = el('div', 'sc-switch' + (tipo ? ' sc-' + tipo : ''), testo);
    box.insertBefore(b, box.firstChild);
  }

  function lingua(root) {
    var lang = (root.dataset.locale || 'en').slice(0, 2).toLowerCase();
    return STR[lang] || STR.en;
  }

  function passaAlCambio(root, email) {
    var t = lingua(root);
    banner(root, t.working, 'work');
    fetch(API + '/withdraw', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'x-returns-token': TOKEN },
      body: JSON.stringify({ order: ordine, email: email, caseNumber: pratica, website: '' })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (b) {
        return { ok: res.ok, body: b };
      });
    }).then(function (r) {
      if (r.ok && r.body && r.body.ok) {
        banner(root, t.done, 'done');
      } else if (r.body && r.body.error === 'too_late') {
        banner(root, t.too_late, 'err');
      } else {
        banner(root, t.err, 'err');
      }
    }).catch(function () {
      banner(root, t.err, 'err');
    });
  }

  function osserva(root) {
    var box = root.querySelector('.sc-returns-box');
    if (!box) return;
    var t = lingua(root);

    function guarda() {
      var form = box.querySelector('.sc-returns-form');
      // Step 1: precompilo l'ordine e spiego perche' si e' qui
      if (form) {
        var inputs = form.querySelectorAll('.sc-returns-input');
        if (inputs.length >= 2 && ordine && !inputs[0].value) {
          inputs[0].value = ordine;
          setTimeout(function () { inputs[1].focus(); }, 80);
        }
        if (!box.querySelector('.sc-switch')) banner(root, t.intro, 'info');
        return;
      }
      // Step 2: riconoscimento superato, ritiro la vecchia richiesta
      if (!fatto && box.querySelector('.sc-returns-items')) {
        fatto = true;
        var email = root.dataset.scEmail || '';
        if (!email) {
          var campi = document.querySelectorAll('input[type=email]');
          for (var i = 0; i < campi.length; i++) if (campi[i].value) email = campi[i].value;
        }
        if (email) passaAlCambio(root, email);
      }
    }

    guarda();
    if (window.MutationObserver) {
      new MutationObserver(guarda).observe(box, { childList: true, subtree: true });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('.sc-returns');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      if (r.dataset.scSwitch) continue;
      r.dataset.scSwitch = '1';
      // L'email va memorizzata mentre il cliente la digita: al passo 2 il
      // campo non esiste piu', perche' il portale riscrive la schermata.
      (function (root) {
        document.addEventListener('input', function (ev) {
          var t2 = ev.target;
          if (t2 && t2.type === 'email' && t2.value) root.dataset.scEmail = t2.value;
        }, true);
        osserva(root);
      })(r);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();